import { Chip, makeStyles } from '@material-ui/core'
import React from 'react'

const useStyles = makeStyles({
  chipRoot: {
    marginLeft: 10,
    fontSize: 8,
    padding: '2px 6px',
    height: 16,
    width: 35,
    '& .MuiChip-label': {
      padding: 0,
    },
  },
})

const TeaserChip = () => {
  const classes = useStyles()

  return <Chip className={classes.chipRoot} label="Pro" color="primary" />
}

export default TeaserChip
